module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tabs",
    style: (("background-color:" + (_vm.globalColors.border)))
  }, _vm._l((_vm.data), function(item) {
    return _c('button', {
      key: item.id,
      staticClass: "tabs-item",
      style: (("border-bottom: 0.6rem solid " + (item.active ? _vm.globalColors.primary : _vm.globalColors.border) + ";")),
      on: {
        "click": function($event) {
          _vm.$emit('select', item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })), _vm._v(" "), _c('div', [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d15be42","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabsProduct.vue
// module id = 1113
// module chunks = 1